var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              data: _vm.tableData,
              option: _vm.tableOption,
              page: _vm.page,
              "table-loading": _vm.tableLoading,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "refresh-change": _vm.refreshChange,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "search-change": _vm.handleFilter,
              "search-reset": _vm.handleSearchReset,
            },
            scopedSlots: _vm._u([
              {
                key: "jobLogStatus",
                fn: function (scope) {
                  return [
                    scope.row.jobLogStatus === "0"
                      ? _c(
                          "div",
                          [
                            _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getDicNameJobExecuteStatus(
                                    scope.row.jobLogStatus
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getDicNameJobExecuteStatus(
                                    scope.row.jobLogStatus
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }